var Base = require('_js/base');
var ko = require('knockout');
var $ = require('jquery');

var model = function() {
  $('.cta').on('click', function() {
    window.location = $(this)
      .find('a')
      .attr('href');
    return false;
  });
};

// Organism
function CallToAction() {
  this.init();
}

CallToAction.prototype = new Base();

CallToAction.prototype.init = function() {
  $('[data-call-to-action]').each(function() {
    ko.applyBindings(new model(), this);
  });
};

module.exports = CallToAction;
